<template>
  <div class="card border border-warning-subtle mb-3">
    <div
      class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
    >
      <div>
        <h6 class="mb-0">{{ $t("forwards.deals.free_escrow.title") }}</h6>
        <span class="text-body-tertiary fs-10">{{
          $t("forwards.deals.free_escrow.subtitle", {
            mwh: formatNumberWithSpaces(totalMwh),
          })
        }}</span>
      </div>
      <button
        v-if="canReturn"
        type="button"
        class="btn btn-sm btn-outline-primary"
        @click="emit('return-to-owner')"
      >
        {{ $t("forwards.deals.free_escrow.return") }}
      </button>
    </div>
    <div class="card-body">
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th scope="col">{{ $t("forwards.deals.free_escrow.company") }}</th>
            <th scope="col">{{ $t("forwards.deals.free_escrow.period") }}</th>
            <th scope="col" class="text-end">
              {{ $t("forwards.common.mwh") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.attribution_id">
            <td>
              {{ row.company_name ?? $t("forwards.common.unknown") }}
            </td>
            <td>{{ row.period_label ?? $t("forwards.common.unknown") }}</td>
            <td class="text-end">{{ formatNumberWithSpaces(row.count) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatNumberWithSpaces } from "@/composables/formatUtils";
import type { FreeEscrowRow } from "@/forwards2/forwardsTypes";
import { sumBy } from "lodash-es";
import { computed } from "vue";

/**
 * Escrow the deal still holds with no live delivery behind it — a cancelled deal's leftovers, or
 * volume freed by a plan edit. It sits on Soldera's escrow account until an admin sends it home,
 * so it is drawn as an open item rather than as part of the plan.
 */
const props = defineProps<{
  rows: FreeEscrowRow[];
  canReturn: boolean;
}>();

const emit = defineEmits<{
  "return-to-owner": [];
}>();

const totalMwh = computed(() => sumBy(props.rows, (row) => row.count));
</script>
